$(() => {
    $('.lots-thumb').each((_, el) => {
        console.log(el);
        const $el = $(el);
        const target = document.getElementById($el.data('target'));
        const image = $el.data('main');
        $el.on('mouseover', () => {
            target.src = image;
        });
    });
});